@if(action()) {
  <button
    type="button"
    (click)="onActionClick($event)"
    class="text-decoration-none app-tile app-tile-{{ color() }}">
    <span class="app-icon d-flex align-items-center justify-content-center">
      <app-icon [icon]="icon()" customClass="icon-20"></app-icon>
    </span>

    <div class="app-info">
      <h5 class="app-title text-dark">
        {{ title() | translate }}
      </h5>

      @if(subtitle() && !isSmall()) {
        <span class="app-subtitle text-dark">{{ subtitle() }}</span>
      }
    </div>
  </button>
} @else {
  <a [routerLink]="[link()]" class="text-decoration-none app-tile app-tile-{{ color() }}">
    <span class="app-icon d-flex align-items-center justify-content-center">
      <app-icon [icon]="icon()" customClass="icon-20"></app-icon>
    </span>

    <div class="app-info">
      <h5 class="app-title text-dark">
        {{ title() | translate }}
      </h5>

      @if(subtitle() && !isSmall()) {
        <span class="app-subtitle text-dark">{{ subtitle() }}</span>
      }
    </div>
  </a>
}